// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"087dedc1","389":"a06f7f28","732":"29a6d09d","977":"36d1fa7f"}[chunkId] + ".chunk.js";
};